import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import {
  getSystemStatus,
  getApiGatewayLogs,
  getDatabaseLogs,
  getBankserverLogs,
  getBankserverHealth,
} from "@/shared/api/services/infrastructure";
import { SERVERS_MOCK_DATA } from "@/shared/data/serversMockData";
import {
  createApiGatewayServer,
  mergeServersData,
} from "@/shared/utils/infrastructureUtils";

const QUERY_CONFIG = { refetchInterval: 5000, staleTime: 3000 };

export default function useInfrastructureSystemData() {
  const { data: systemStats, refetch: refreshSystemStats } = useQuery({
    queryKey: ["systemStatus"],
    queryFn: getSystemStatus,
    ...QUERY_CONFIG,
  });

  const { data: apiGatewayLogs, refetch: refreshApiGatewayLogs } = useQuery({
    queryKey: ["apiGatewayLogs"],
    queryFn: () => getApiGatewayLogs(100),
    ...QUERY_CONFIG,
  });

  const { data: databaseLogs, refetch: refreshDatabaseLogs } = useQuery({
    queryKey: ["databaseLogs"],
    queryFn: () => getDatabaseLogs(100),
    ...QUERY_CONFIG,
  });

  const { data: bankserverHealth, refetch: refreshBankserverHealth } = useQuery({
    queryKey: ["bankserverHealth"],
    queryFn: getBankserverHealth,
    ...QUERY_CONFIG,
  });

  const { data: bankserverLogs, refetch: refreshBankserverLogs } = useQuery({
    queryKey: ["bankserverLogs"],
    queryFn: () => getBankserverLogs(),
    ...QUERY_CONFIG,
  });

  const displayServers = useMemo(() => {
    const apiGw = createApiGatewayServer(systemStats?.apiGateway, systemStats?.apiGateway?.latencyMs);
    return mergeServersData(SERVERS_MOCK_DATA, systemStats, apiGw, bankserverHealth, bankserverLogs);
  }, [systemStats, bankserverHealth, bankserverLogs]);

  return {
    systemStats,
    bankserverHealth,
    displayServers,
    refetchers: {
      refreshSystemStats,
      refreshApiGatewayLogs,
      refreshDatabaseLogs,
      refreshBankserverHealth,
      refreshBankserverLogs,
    },
  };
}
